export const UIA_MODAL_WORKFLOW = {
  SET_CURRENT_WORKFLOW: 'SET_CURRENT_WORKFLOW',
  SET_CURRENT_INDEX: 'SET_CURRENT_INDEX',
};
